import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import { API, setToken } from '../apiClient';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) {
        setErr(typeof data.error === 'string' ? data.error : 'Login failed');
        return;
      }
      if (!data.token || typeof data.token !== 'string') {
        setErr('Invalid response from server');
        return;
      }
      setToken(data.token);
      navigate('/', { replace: true });
    } catch {
      setErr('Cannot reach server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dns-page dash-page login-page-root">
      <div className="login-page-card">
        <div className="login-page-brand">
          <div className="brand-icon login-page-icon" aria-hidden>
            <Lock size={22} />
          </div>
          <div>
            <h1 className="login-page-title">MapNexa</h1>
            <p className="login-page-sub">Sign in to continue</p>
          </div>
        </div>
        <form className="login-page-form" onSubmit={(e) => void submit(e)}>
          <label className="login-page-label">
            <span>Username</span>
            <input
              className="cfg-input"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />
          </label>
          <label className="login-page-label">
            <span>Password</span>
            <input
              className="cfg-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
          </label>
          {err ? <p className="login-page-err" role="alert">{err}</p> : null}
          <button type="submit" className="btn btn-primary login-page-submit" disabled={loading}>
            {loading ? <Loader2 size={16} className="spin" /> : null}
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
